// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hinweis-background-first {
    position: fixed;
    top: 80px;
    left: 0;
    align-self: center;
    width: 100%;
    height: calc(100% - 80px);
    background: rgba(0, 0, 0, 0.7);
    z-index: 98 !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.hinweis-content-container-first {
    position: relative;
    display: flex;
    flex-direction: column;
    align-self: center;
    width: 50%;
    height: fit-content;
    max-height: 80vh;
    background-color: var(--white-base);
    border-radius: 20px;
    
    /* Text Style */
    font-family: 'Poppins', sans-serif;
    font-weight: normal;
    font-size: 16px;
    text-align: left;
    line-height: 1.5;
    margin-bottom: 10px;
}

.hinweis-inner-container{
    margin: 20px;
    overflow-y: auto;
}

/* Style the scrollbar for Chrome, Safari, and Opera */
.hinweis-inner-container::-webkit-scrollbar-first {
    width: 12px;
    margin-left: -200px; /* Move scrollbar 20px to the left */
}

.hinweis-inner-container::-webkit-scrollbar-track-first {
    background: var(--gray-20); /* color of the track */
    border-radius: 10px; /* rounded corners */
}

.hinweis-inner-container::-webkit-scrollbar-thumb-first {
    background-color: var(--blue-60); /* color of the thumb */
    border-radius: 10px; /* rounded corners */
    border: 2px solid var(--scrollbar-thumb-border-color); /* border around the thumb */
}

.hinweis-toggle-close-button-first {
    position: absolute;
    top: 20px;
    right: 20px;
    left: 20px;
    width: 35px;
    height: 35px;
    color: var(--white-base);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    font-size: 24px;
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    text-align: center;
}

.hinweis-title-first {
    font-size: 28px;
    margin-top: 10px;
    font-weight: 700;
}

.hinweis-text-first {
    margin-top: 10px;
    font-size: 16px;
}


.disclaimer-button-first {
    position: relative;
    display: flex;
    justify-content: center;
    align-self: center;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    width: fit-content;
    border-radius: 20px;
    background-color: var(--border);
    padding: 0px 15px;
    -webkit-user-select: none;
            user-select: none;
    color: var(--white-base);

    /* TEXT STYLE */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}
.assessment-starten-first {
    position: relative;
    width: fit-content;
    margin-right: 20px;
    padding: 0px 20px;
    background-color: var(--blue-50)
}

.ausloggen-first {
    position: relative;
    width: fit-content;
    padding: 0px 20px;
    margin-left: 20px;
    background-color: var(--assessment-lv1);
}`, "",{"version":3,"sources":["webpack://./src/widgets/FirstLoginNoAssessmentPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;;IAEnB,eAAe;IACf,kCAAkC;IAClC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA,sDAAsD;AACtD;IACI,WAAW;IACX,mBAAmB,EAAE,oCAAoC;AAC7D;;AAEA;IACI,0BAA0B,EAAE,uBAAuB;IACnD,mBAAmB,EAAE,oBAAoB;AAC7C;;AAEA;IACI,gCAAgC,EAAE,uBAAuB;IACzD,mBAAmB,EAAE,oBAAoB;IACzC,qDAAqD,EAAE,4BAA4B;AACvF;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,eAAe;IACf,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;IACjB,wBAAwB;;IAExB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uCAAuC;AAC3C","sourcesContent":[".hinweis-background-first {\r\n    position: fixed;\r\n    top: 80px;\r\n    left: 0;\r\n    align-self: center;\r\n    width: 100%;\r\n    height: calc(100% - 80px);\r\n    background: rgba(0, 0, 0, 0.7);\r\n    z-index: 98 !important;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.hinweis-content-container-first {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-self: center;\r\n    width: 50%;\r\n    height: fit-content;\r\n    max-height: 80vh;\r\n    background-color: var(--white-base);\r\n    border-radius: 20px;\r\n    \r\n    /* Text Style */\r\n    font-family: 'Poppins', sans-serif;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    text-align: left;\r\n    line-height: 1.5;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.hinweis-inner-container{\r\n    margin: 20px;\r\n    overflow-y: auto;\r\n}\r\n\r\n/* Style the scrollbar for Chrome, Safari, and Opera */\r\n.hinweis-inner-container::-webkit-scrollbar-first {\r\n    width: 12px;\r\n    margin-left: -200px; /* Move scrollbar 20px to the left */\r\n}\r\n\r\n.hinweis-inner-container::-webkit-scrollbar-track-first {\r\n    background: var(--gray-20); /* color of the track */\r\n    border-radius: 10px; /* rounded corners */\r\n}\r\n\r\n.hinweis-inner-container::-webkit-scrollbar-thumb-first {\r\n    background-color: var(--blue-60); /* color of the thumb */\r\n    border-radius: 10px; /* rounded corners */\r\n    border: 2px solid var(--scrollbar-thumb-border-color); /* border around the thumb */\r\n}\r\n\r\n.hinweis-toggle-close-button-first {\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    left: 20px;\r\n    width: 35px;\r\n    height: 35px;\r\n    color: var(--white-base);\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    font-size: 24px;\r\n    display: flex;\r\n    justify-content: center; /* Center horizontally */\r\n    align-items: center; /* Center vertically */\r\n    text-align: center;\r\n}\r\n\r\n.hinweis-title-first {\r\n    font-size: 28px;\r\n    margin-top: 10px;\r\n    font-weight: 700;\r\n}\r\n\r\n.hinweis-text-first {\r\n    margin-top: 10px;\r\n    font-size: 16px;\r\n}\r\n\r\n\r\n.disclaimer-button-first {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-self: center;\r\n    margin-top: 40px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    cursor: pointer;\r\n    width: fit-content;\r\n    border-radius: 20px;\r\n    background-color: var(--border);\r\n    padding: 0px 15px;\r\n    user-select: none;\r\n    color: var(--white-base);\r\n\r\n    /* TEXT STYLE */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 150%;\r\n}\r\n.assessment-starten-first {\r\n    position: relative;\r\n    width: fit-content;\r\n    margin-right: 20px;\r\n    padding: 0px 20px;\r\n    background-color: var(--blue-50)\r\n}\r\n\r\n.ausloggen-first {\r\n    position: relative;\r\n    width: fit-content;\r\n    padding: 0px 20px;\r\n    margin-left: 20px;\r\n    background-color: var(--assessment-lv1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
